import rightImg from "images/aboutsection.png";
import { FC } from "react";
import SectionStatistic from "./SectionStatistic";
import { Helmet } from "react-helmet";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import SectionHero from "./SectionHero";
import SectionClientSay from "components/SectionClientSay/SectionClientSay";
import { globalJson } from "global/global_json";
import ReadytoDrive from "./ReadytoDrive";
import readytodrive from "images/readytodrive.png";
import DreamCarSection from "components/DreamYourCar/DreamYourCar";

export interface PageAboutProps {
  className?: string;
}

const PageAbout: FC<PageAboutProps> = ({ className = "" }) => {
  return (
    <div
      className={`nc-PageAbout overflow-hidden relative ${className}`}
      data-nc-id="PageAbout"
    >
      <Helmet>
        <title>About</title>
      </Helmet>

      <div className="container relative py-16">
        <SectionHero
          rightImg={rightImg}
          heading="Welcome to Kings Car Rentals"
          btnText=""
          subHeading={globalJson?.about_us_para}
        />
      </div>
      <div
        style={{
    background:
      "linear-gradient(0deg, rgba(0, 0, 0, 0) -34.51%, rgba(215, 172, 29, 0.6) -6.25%, rgba(253, 227, 6, 0.375) 12.43%, rgba(253, 227, 6, 0.075) 63.42%, rgba(0, 0, 0, 0) 100%)",
  }}
      >
        <div className="container relative py-16">
          <DreamCarSection />
        </div>
      </div>
      <div className="bg-[#FFFFFF0D]">
        <div className="container">
          <div className=" mt-12 rounded-3xl">
            <div className="relative py-16 ">
              <SectionClientSay uniqueClassName="PageAbout_" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageAbout;
